import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { RxStompService } from '@stomp/ng2-stompjs';
import { ModalController } from '@ionic/angular';
import { AccetOrDeclineCallComponent } from './accet-or-decline-call/accet-or-decline-call.component';
import {RutasWebServices} from "../../services/rutasWebServices";
import { tap, map, catchError } from "rxjs/operators";

@Injectable()
export class ZeusConferenceService {

    constructor(private http: HttpClient, private rxStompService: RxStompService, private modalController: ModalController) { }

    SafeRecord(dataRecord) {
        const header = {
            PathFile: dataRecord.path,
            EmailZoom: dataRecord.email,
            DateStartMetting: dataRecord.StartMeet,
            DateEndtMetting:  dataRecord.EndtMeet
        };
        this.rxStompService.publish({ destination: '/topic/transfer.file', headers: header, body: JSON.stringify(header) });

    }
    SendInvitation(dataUser) {
        const header = {
            Subject: dataUser.subject,
            To: {
                Email: dataUser.email,
                FullName: dataUser.fullname,
                PhoneNumber: dataUser.number,
                User : dataUser.User,
                MeetingNumber : dataUser.MeetingNumber

            },
            Url: dataUser.Url
        };
        console.log(header);
        this.rxStompService.publish({ destination: '/topic/send.conference.mail.' +
        dataUser.User, headers: header.To, body:JSON.stringify(header) });

    }

    async ReciedInvitation(params) {
        console.log(params);
        const modal = await this.modalController.create({
            component: AccetOrDeclineCallComponent,
            componentProps: {
              _parent: this,
              params,
              cssClass: 'custom-Class-modal'
            }
          });
        return await modal.present();
    }

    httpGet(route: string, httpOptions) {
        return new Promise((resolve, reject) => {
            this.http.get(route, httpOptions).subscribe((res) => {
                resolve(res);
            }, (e) => {
                console.log(e);
                reject(e);
            });
        });
    }


    guardarDatosConferencia(IdUsuario:number,Estudio:number){
		//let dataUser=JSON.parse(sessionStorage.getItem('dataUser'));
		let params=$.param({IdUsuario:IdUsuario, Estudio:Estudio});
		let rutasWS = new RutasWebServices();
        
        const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type':  'application/x-www-form-urlencoded'
			}),
			params: new HttpParams().set('IdUsuario', IdUsuario+'')
									.set('Estudio', Estudio+'') 
		};	
        
		return this.http.post(rutasWS.urlWebService("GuardarDatosInicialesConferencia"),params,httpOptions).pipe(
			map(res => res),
			tap(res => {
				  
				},
				err => {
				  
				})
		  )
		//return this._http.post(rutasWS.urlWebService("SaveFormatoEvolucion"),params).map(res => res.json());
	}

}
